import React, { Component } from 'react'
import SimpleDataTable from '../../../../../../modules/SimpleDataTable'
import { configReportAppointmentToday, SAMPLE_DATA_REPORT_STATISTIC_PROSPECT_TODAY } from '../config'
import * as R from 'ramda'
import { fetchDataAsync } from '../../../../../../Services/Utils';
import Api from '../../../../../../Services/Api';
import { HttpStatus } from '../../../../../common/Constants';
export default class ReportAppointmentFollowupToday extends Component {
   constructor(props){
      super(props);
      this.state = {
        dataTable: [],
      };
    }
  
    componentDidUpdate(prevProps, prevState) { 
      if(this.props.doSearch && !R.equals(prevProps.doSearch,this.props.doSearch)){
        this.fetchData()
      }
    } 
  
    fetchData = async () =>{
      try{
        this.props.triggerLoading()
        const res = await fetchDataAsync({
          asyncFn: Api.create("NAGAMAS_REPORT_DTO").getLaporanAppointmentFUToDay,
          setError: this.props.setError,
          menuName: "Dashboard CRM Koordinator - Statistik Appointment Hari ini",
          args: {
            kodeCabang: this.props.search.kodeCabang,
            teamLeaderEmployeeId: this.props.search?.teamLeader || null,
          },
        });
        this.props.onSuccessSearch()
        this.props.triggerLoading()
        if(res.ok && res.data.status === HttpStatus.SUCCESS){
          this.setState(prev=>({
            ...prev,
            dataTable: res.data.data
          }))
        }
      }catch(e){
        this.props.triggerLoading()
        this.props.onSuccessSearch()
        console.log(e)
      }
    }
  render() {
    return (
      <div style={{ padding: "10px" }}>
        <p style={{ fontWeight: "bold", marginBottom: "10px" }}>
          LAPORAN APPOINTMENT FOLLOWUP HARI INI
        </p>
        <SimpleDataTable
          data={this.state.dataTable}
          columns={configReportAppointmentToday}
          rowsPerPage={5}
          page={0}
          options={{serverSide: false}}
        />
      </div>
    );
  }
}